export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] border-t border-[#2a2a2a] py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/2646c0d9-40fb-45bd-88c3-566ccc6efb39.png" 
              alt="ProtectWhatsMine Logo" 
              className="h-10 w-10 object-contain"
            />
            <div>
              <p className="text-white font-bold text-lg">ProtectWhatsMine.com</p>
              <p className="text-gray-500 text-sm">In Affiliation with KKOS Lawyers</p>
            </div>
          </div>

          <div className="text-center md:text-right">
            <p className="text-gray-500 text-sm">
              © 2026 ProtectWhatsMine.com. All rights reserved.
            </p>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-[#2a2a2a] text-center">
          <p className="text-gray-600 text-xs max-w-3xl mx-auto">
            This website is for informational purposes only and does not constitute legal advice. 
            Consult with a qualified attorney for advice specific to your situation.
          </p>
        </div>
      </div>
    </footer>
  );
}